import { useEffect } from "react";

export default function ComingSoon() {
  useEffect(() => {
    document.title = "Wen Moon";
  }, []);

  return (
    <div
      data-testid="coming-soon-page"
      className="relative min-h-screen w-full overflow-hidden bg-black text-white flex flex-col items-center justify-center px-6"
    >
      <style>{`
        @keyframes mj-glow {
          0%, 100% { opacity: 0.35; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.08); }
        }
        @keyframes mj-float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes mj-rise {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes mj-twinkle {
          0%, 100% { opacity: 0.15; }
          50% { opacity: 0.7; }
        }
        .mj-rise { opacity: 0; animation: mj-rise 0.9s ease-out forwards; }
      `}</style>

      {/* starfield */}
      <div className="pointer-events-none absolute inset-0">
        {[...Array(40)].map((_, i) => (
          <span
            key={i}
            className="absolute rounded-full bg-amber-200"
            style={{
              top: `${(i * 37) % 100}%`,
              left: `${(i * 61) % 100}%`,
              width: i % 5 === 0 ? "2px" : "1px",
              height: i % 5 === 0 ? "2px" : "1px",
              animation: `mj-twinkle ${3 + (i % 5)}s ease-in-out ${i * 0.13}s infinite`,
            }}
          />
        ))}
      </div>

      {/* gold radial glow behind logo */}
      <div className="pointer-events-none absolute left-1/2 top-[42%] -translate-x-1/2 -translate-y-1/2">
        <div
          className="rounded-full"
          style={{
            width: "620px",
            height: "620px",
            background:
              "radial-gradient(circle, rgba(245,197,24,0.28) 0%, rgba(245,197,24,0.08) 40%, rgba(0,0,0,0) 70%)",
            filter: "blur(8px)",
            animation: "mj-glow 6s ease-in-out infinite",
          }}
        />
      </div>

      {/* logo */}
      <img
        data-testid="coming-soon-logo"
        src="/moonjuice-logo.jpeg"
        alt="Wen Moon"
        className="relative z-10 w-40 h-40 sm:w-52 sm:h-52 rounded-full ring-1 ring-amber-400/30 shadow-[0_0_80px_rgba(245,197,24,0.25)] mj-rise"
        style={{ animationDelay: "0.05s", animation: "mj-float 7s ease-in-out infinite, mj-rise 0.9s ease-out forwards" }}
      />

      {/* wordmark */}
      <h1
        data-testid="coming-soon-title"
        className="relative z-10 mt-10 text-4xl sm:text-6xl font-semibold tracking-tight mj-rise"
        style={{ animationDelay: "0.2s" }}
      >
        <span className="bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent">
          Wen Moon
        </span>
      </h1>

      {/* tagline */}
      <p
        data-testid="coming-soon-tagline"
        className="relative z-10 mt-6 max-w-xl text-center text-base sm:text-lg text-amber-100/70 mj-rise"
        style={{ animationDelay: "0.35s" }}
      >
        Everyone asks "Wen Moon Ser?"
      </p>
      <p
        className="relative z-10 mt-2 max-w-xl text-center text-base sm:text-lg text-amber-100/40 mj-rise"
        style={{ animationDelay: "0.5s" }}
      >
        Stop asking wen. Launch it to the moon.
      </p>

      {/* coming soon pill */}
      <div
        data-testid="coming-soon-badge"
        className="relative z-10 mt-12 mj-rise"
        style={{ animationDelay: "0.7s" }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-amber-400/5 px-6 py-2 text-sm uppercase tracking-[0.25em] text-amber-200/80">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-400 animate-pulse" />
          Coming Soon
        </span>
      </div>

      {/* footer */}
      <div className="absolute bottom-6 left-0 right-0 text-center text-xs text-amber-100/25">
        © {new Date().getFullYear()} Wen Moon
      </div>
    </div>
  );
}
